import React from 'react';
import { motion } from 'framer-motion';

const Future = () => {
  return (
    <section className="prose prose-invert max-w-none">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="card bg-gradient-to-br from-brand/5 to-background p-8"
      >
        <h2 className="text-2xl font-bold mb-6">The Future of Animatronics</h2>
        <p className="text-lg leading-relaxed">
          From the enchanting illusions of the Tiki Birds to the high-flying stunt robotics of Stuntronics, animatronics has evolved into a powerful storytelling medium—melding engineering, artistry, and cutting-edge technology. Disney, a pioneer in this field, continues to push the boundaries of what animatronics can achieve with ambitious expansions like Zootopia Land at Shanghai Disneyland. These large-scale, IP-driven animatronic installations align with the findings of the TEA/AECOM 2023 Theme Index, which highlights the strong correlation between IP-based expansions and increased park attendance.
        </p> 
      <p className="text-lg leading-relaxed">
As artificial intelligence advances and guest expectations for immersive experiences grow, animatronics is poised for its next great leap. Innovations in AI, robotics, and material sciences promise to make animatronics even more lifelike and responsive, creating characters that interact dynamically with guests and their surroundings. The future of animatronics lies not only in delivering visual spectacle but also in crafting unforgettable, emotionally resonant experiences that deepen the connection between audiences and the stories they love.

        </p>
      </motion.div>
    </section>
  );
};

export default Future;